const build = `source 'https://rubygems.org/'

gem 'sinatra'
gem 'stripe'
`;

export default {
  build,
};
